<template>
  <div>
    <div class="bg-white py-3 py-md-5">
      <b-container class="d-flex flex-wrap align-items-center">
        <h1 class="col-12 col-md-auto p-0">{{ 'componentTitle' | translate(labels, 'servicelibrary_ServiceLibraryComponent') }}</h1>
        <b-link v-if="usb" to="/usb" class="font-condensed d-flex align-items-center ml-md-4 col-12 col-md-auto p-0 my-3 my-md-0"><b-icon icon="bobcaticon-usb" class="text-small mr-2" />{{ 'componentTitle' | translate(labels, 'servicelibrary_USBFormComponent') }}</b-link>
        <b-row v-if="regionalizedFeatures && regionalizedFeatures.errorReportAccess">
          <b-col cols="12">
            <ServiceLibraryErrorReport />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container>
      <b-row>
        <b-col cols="12" class="pt-4">
          <ServiceLibraryComponent />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ServiceLibraryComponent from '@/components/ServiceLibrary/ServiceLibraryComponent'
import ServiceLibraryErrorReport from '@/components/ServiceLibrary/ServiceLibraryErrorReport.vue'
import {mapGetters} from 'vuex'

export default {
  conceptName: ['servicelibrary_ServiceLibraryComponent', 'servicelibrary_USBFormComponent'],
  components: {
    ServiceLibraryErrorReport,
    ServiceLibraryComponent
  },
  computed: {
    ...mapGetters({
      regionalizedFeatures: 'servicelibrary/getRegionalizedFeatures'
    })
  },
  props: {
    usb: {
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/grid";

@include media-breakpoint-down('xs') {
  h1 {
    font-size: 1.5rem;
  }
}
</style>
